import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import '../pages/LandingPage.css'; // For basic utility classes

export default function NotFoundPage() {
  const { t } = useTranslation();
  console.log('NOT FOUND PAGE IS RENDERING! Location:', window.location.pathname);
  
  return (
    <>
      <Helmet>
        <title>{t('notFound.pageNotFound')} | Reviio</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <SiteHeader />
      
      <main className="landing-main not-found-main">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">{t('notFound.pageNotFound')}</h2>
        <p className="not-found-text">{' ' + t("notFound.thePageYouReLookingFor")}
        </p>
        <div style={{ display: 'flex', gap: 'var(--spacing-md)' }}>
          <Link to="/" className="btn btn-primary">{t('notFound.backToHome')}</Link>
          <Link to="/blog" className="btn btn-secondary">{t('notFound.readOurBlog')}</Link>
        </div>
      </main>
      
      <SiteFooter />
    </>
  );
}
